import { MapModel } from '@/types/models';
import { getBounds } from '@/services/pluginsManager/map/data/getBounds';
import { MapDownloadPoint } from './getMapDownloadBodyRequest';

export interface ImageDownloadBodyRequest {
  imageFormat: string;
  polygon: MapDownloadPoint[];
  zoomLevel: number;
  /** applied in the given order - a later overlay wins over an earlier one for the same element */
  overlayIds: number[];
}

/**
 * Builds the body of POST /projects/{projectId}/maps/{mapId}:download_image.
 * `imageFormat` is an ImageGeneratorEnum value - it comes from ImageFormat.generator,
 * see imageHandlersSelector.
 */
export const getImageDownloadBodyRequest = ({
  imageFormat,
  model,
  zoom,
  overlayIds,
  currentView,
}: {
  imageFormat: string;
  model: MapModel;
  zoom: number;
  overlayIds: number[];
  currentView?: boolean;
}): ImageDownloadBodyRequest => {
  let polygon: MapDownloadPoint[] = [
    { x: 0, y: 0 },
    { x: model.width, y: 0 },
    { x: model.width, y: model.height },
    { x: 0, y: model.height },
  ];

  if (currentView) {
    const bounds = getBounds();
    if (bounds) {
      const { x1, y1, x2, y2 } = bounds;
      polygon = [
        { x: x1, y: y1 },
        { x: x1, y: y2 },
        { x: x2, y: y2 },
        { x: x2, y: y1 },
      ];
    }
  }

  return {
    imageFormat,
    polygon,
    zoomLevel: zoom,
    overlayIds,
  };
};
